import React, { Component } from "react";
import { Button2 } from "../button/button";
import Navbar from "../navbar/navbar";
import "./contact.css";
import "../home/home.css";
class Contact extends Component {
	render() {
		return (
			<section id="contact" className="contact-area pt-80 pb-130">
				<div className="header-area">
					<div id="home" className="contact-header-area  bg_cover">
						<Navbar />
						<div className=" d-flex align-items-center">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-10">
										<div className="header-content text-center">
											<h2 className="header-title2">CONTACT US</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="container">
					<div className="row contact-section-area">
						<div className="col-lg-4">
							<div className="contact-info pt-40">
								<div className="section-title pb-10">
									<h2 className="title">Get In Touch</h2>
								</div>
								<ul>
									<li>
										<div className="single-info d-flex mt-25">
											<div className="info-icon">
												<i className="far fa-envelope"></i>
											</div>
											<div className="info-content media-body">
												<h6 className="info-title">Email address</h6>
												<p className="text">info@kccemsr.edu.in</p>
											</div>
										</div>
									</li>
									{/* <li>
                    <div className="single-info d-flex mt-25">
                      <div className="info-icon">
                        <i className="fas fa-phone"></i>
                      </div>
                      <div className="info-content media-body">
                        <h6 className="info-title">Phone Number</h6>
                        <p className="text">+91 123 456 7890</p>
                      </div>
                    </div>
                  </li> */}
									<li>
										<div className="single-info d-flex mt-25">
											<div className="info-icon">
												<i className="fas fa-map-marker"></i>
											</div>
											<div className="info-content media-body">
												<h6 className="info-title">Location</h6>
												<p className="text">
													K. C. College of Engineering and Management Studies
													and Research, Sadguru gardens, Mith Bunder Road, near
													Kopri, Valmiki nagar, Thane (East) 400603,
													Maharashtra, India.
												</p>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-8">
							<div className="contact-form pt-20">
								<form id="contact-form" onSubmit={this.handleContactForm}>
									<div className="row">
										<div className="col-md-6">
											<div className="single-form">
												<input
													type="text"
													name="name"
													placeholder="Your Name"
												/>
												<i className="fas fa-user"></i>
											</div>
										</div>
										<div className="col-md-6">
											<div className="single-form">
												<input
													type="email"
													name="email"
													placeholder="Your Email"
												/>
												<i className="far fa-envelope"></i>
											</div>
										</div>
										<div className="col-md-6">
											<div className="single-form">
												<input
													type="text"
													name="subject"
													placeholder="Your Subject"
												/>
												<i className="fas fa-pen-square"></i>
											</div>
										</div>
										<div className="col-md-6">
											<div className="single-form">
												<input
													type="text"
													name="number"
													placeholder="Phone Number"
												/>
												<i className="fas fa-phone"></i>
											</div>
										</div>
										<div className="col-md-12">
											<div className="single-form">
												<textarea
													name="message"
													placeholder="Your Message"
												></textarea>
												<i className="far fa-comment-alt"></i>
											</div>
										</div>
										<p className="form-message"></p>
										<div className="col-md-6">
											<div className="single-form">
												<Button2 label="Send Message" type="submit" />
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div className="contact-team">
						<h5 className="title text-center">
							For any query e-mail us at info@kccemsr.edu.in or contact
							undersigned
						</h5>
						<div className="row">
							<div className="col-sm-12 col-md-6 col-lg-6 contact-extra-team">
								<h6 className="info-title">Dr. Avishek Ray</h6>
								<a
									href="mailto:avishek.ray@kccemsr.edu.in"
									className="info-title-email"
								>
									avishek.ray@kccemsr.edu.in{" "}
								</a>
								<p className="info-title-semi">Associate Professor</p>
								<p className="text">
									Department of Electronics and Telecommunication Engineering,
									K. C. College of Engineering and Management Studies and
									Research, Thane,400603
								</p>{" "}
								<br />
								<p>
									Phone :
									<a href="tel:+919038634182" className="info-title-email">
										9038707191
									</a>
								</p>
							</div>
							{/* 
              <div className="col-sm-12 col-md-6 col-lg-3 contact-extra-team">
                <h6 className="info-title">Dr. Shobha Tyagi</h6>
                <p className="info-title-semi">Associate Professor</p>
                <p className="text">
                  Department of Information Technology, K. C. College of Engineering and Management Studies and Research, Thane, 400603
                </p>{" "}
                <br />
                <p>
                  Phone :
                  <a href="tel:+919820456140" className="info-title-email">
                    9820456140
                  </a>
                </p>
                <a
                  href="mailto:shobha.tyagi@kccemsr.edu.in"
                  className="info-title-email"
                >
                  shobha.tyagi@kccemsr.edu.in
                </a>
              </div> */}
							<div className="col-sm-12 col-md-6 col-lg-6 contact-extra-team">
								<h6 className="info-title">Dr. Poulami Das</h6>
								<a
									href="mailto:poulami.das@kccemsr.edu.in"
									className="info-title-email"
								>
									poulami.das@kccemsr.edu.in
								</a>
								<p className="info-title-semi">Assistant Professor</p>
								<p className="text">
									Department of Computer Engineering, K. C. College of
									Engineering and Management Studies and Research, Thane,400603
								</p>{" "}
								<br />
								<p>
									Phone :
									<a href="tel:+919038634182" className="info-title-email">
										9038634182
									</a>
								</p>
							</div>
							{/* 
							<div className="col-sm-12 col-md-6 col-lg-4 contact-extra-team">
								<h6 className="info-title">Mr. Yogesh Karunakar</h6>
								<a
									href="mailto:yogesh.karunakar@kccemsr.eedu.in"
									className="info-title-email"
								>
									yogesh.karunakar@kccemsr.eedu.in
								</a>
								<p className="info-title-semi">Assistant Professor</p>
								<p className="text">
									Department of Electronics and Telecommunication Engineering,
									K. C. College of Engineering and Management Studies and
									Research, Thane,400603
								</p>
								<br />
							</div> */}
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<div className="contact-map pt-130">
								<div className="gmap_canvas">
									<iframe
										id="gmap_canvas"
										src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15073.322893996616!2d72.97659269573975!3d19.180752061514827!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb4f1e032d9e4fc41!2sK%20C%20College%20Of%20Engineering%20Management%20Studies%20And%20Research!5e0!3m2!1sen!2sin!4v1602999676990!5m2!1sen!2sin"
										frameBorder="0"
										scrolling="no"
										marginHeight="0"
										marginWidth="0"
									></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}

	handleContactForm = (e) => {
		e.preventDefault();
	};
}

export default Contact;
